/**
 * SAP CONFIDENTIAL
 *
 * This software is confidential proprietary software licensed by SAP SE
 * and is not to be used, duplicated or disclosed to anyone without the
 * prior written permission of SAP.
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable()
export class UserProfileService {
  private userProfileUrl: string = environment.host + '/profile/';
  private languageMetaUrl: string = environment.host + '/language/metadata';
  private updatePasswordUrl: string = environment.host + '/profile/password';
  private unlockUserUrl: string = environment.host + '/inActiveMailReset';

  constructor(private http: HttpClient) {}

  public getHomeMetaDetails() {
    return this.http.get(this.userProfileUrl.toString()).toPromise();
  }

  public getLanaguageDetails() {
    return this.http.get(this.languageMetaUrl.toString()).toPromise();
  }

  public updateProfileDetails(payload: any) {
    return this.http.put(this.userProfileUrl.toString(), payload).toPromise();
  }

  public updatePasswordDetails(payload: any) {
    return this.http.put(this.updatePasswordUrl.toString(), payload).toPromise();
  }

  public unlockUser(payload: any) {
    return this.http.put(this.unlockUserUrl.toString(), payload).toPromise();
  }
}
